export const EOIRCaseInfoMutations = {}
